import PropTypes from "prop-types";
import { Box, Drawer, Toolbar, useMediaQuery } from "@mui/material";
import { drawerWidth } from ".././../../config";
import { useState } from "react";
import { setSidebarOpen, useSettingsSelector } from "../../../store/global/settingsSlice";
import { useDispatch } from "react-redux";

function SidebarWrapper({ window, sidebar }) {
    const {
        sidebar: { open },
    } = useSettingsSelector();
    const matchWindowSize = useMediaQuery((theme) => theme.breakpoints.up("sm"));
    const container = window !== undefined ? () => window().document.body : undefined;
    const dispatch = useDispatch();
    const handleSidebarToggle = () => dispatch(setSidebarOpen(!open));

    return (
        <Box component="nav" sx={{ flexShrink: 1 }}>
            {matchWindowSize ? (
                <Drawer
                    variant="permanent"
                    anchor="left"
                    open={open}
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        display: { xs: "none", sm: "block" },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: drawerWidth,
                        },
                    }}
                >
                    <Toolbar variant="dense" />
                    {sidebar}
                </Drawer>
            ) : (
                <Drawer
                    container={container}
                    variant="temporary"
                    open={open}
                    onClose={handleSidebarToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: "block", sm: "none" },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: drawerWidth,
                        },
                    }}
                >
                    <Toolbar variant="dense" />
                    {sidebar}
                </Drawer>
            )}
        </Box>
    );
}

SidebarWrapper.propTypes = {
    sidebar: PropTypes.element,
};

export default SidebarWrapper;
